import styled from 'styled-components'

export const StyledAccordion = styled.div`
  border-bottom: solid 1px ${({ theme }) => theme.colors.black[1]};
  .prose {
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`

export const StyledAccordionHeader = styled.div`
  padding: 1.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const StyledAccordionHeaderMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StyledAccordionBody = styled.div`
  overflow: hidden;
  transition: height 0.2s ease-out;
`
